var map = {
	"./skopei-360-inline.svg": 575,
	"./skopei-360-only.svg": 576,
	"./skopei-360.svg": 577,
	"./skopei-s.svg": 578,
	"./skopei.svg": 579
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 574;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos ^\.\/.*\.svg$
// module id = 574
// module chunks = 14